<script setup>
import { computed, TransitionGroup } from 'vue'
// this component neened to import as child in FeatureListItem
import { FeatureListItem } from '@/components/features'

const props = defineProps({
  features: {
    type: Array,
    required: true,
  },
  isChild: {
    type: Boolean,
    default: false,
  }
})

const featuresToRender = computed(() => props.isChild ? props.features : props.features.filter(f => !f.properties.parent_code))

</script>

<template>
  <TransitionGroup name="feature-list" tag="div">
    <FeatureListItem
      class="w-full"
      v-for="(feature, index) in featuresToRender"
      :feature="feature"
      :key="feature.properties.code"
    />
  </TransitionGroup>
</template>

<style scoped>
.feature-list-enter-active,
.feature-list-leave-active {
  transition: all 0.2s ease;
}
.feature-list-enter-from {
  opacity: 0;
  transform: translateY(8px);
}
.feature-list-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
.feature-list-move {
  transition: transform 0.2s ease;
}
</style>
